export enum CustomerType {
  USER = 'user',
  SHOP = 'shop',
}
